import React, { useEffect, useState } from 'react';

import { Button } from 'antd';
import MaterialButton from '@/components/MaterialButton';

import { isConference, isCorporateCourse, isExecutiveTask, isExternalCourse } from '@shared/utils/topic-utils';

import css from '../CollectionMaterialsIDStudy.module.scss';

import { APPROVED, APPROVED_STATUSES, FINISHED, WAITING, WAITING_BY_USER } from '@/constants/study-plan-statuses';

const TopicStudyInfo = ({
  t,
  topic,
  statistic,
  isFinished,
  isLoading,
  topicTypeId,
  alreadyFinished,
  topicPlanStatus,
  next,
  handleEndMaterialButton,
  handleEndMaterialButtonOK,
  // setShowCalendar,
  isExecutiveFinished,
  loadData,
}) => {
  const [autoFinish, setAutoFinish] = useState(false);

  useEffect(() => {
    if (
      !isLoading &&
      topicPlanStatus === 'inPlan' &&
      statistic &&
      isNot25Type &&
      !next &&
      !isFinished &&
      !alreadyFinished &&
      statistic.isAvailableForViewBlocks &&
      !autoFinish
    ) {
      setAutoFinish(true);
      handleEndMaterialButtonOK();
    }
  }, [statistic]);

  if (isLoading) return null;

  const isNot25Type = !isExecutiveTask(topicTypeId);
  const isCorpCourse = isCorporateCourse(topicTypeId);

  const isWaiting = topic?.planStatus?.planStatus === WAITING;
  const isApprovedStatus = topic?.planStatus?.planStatus === APPROVED;
  const isApproved = APPROVED_STATUSES.includes(topic?.planStatus?.planStatus);

  const isExternalOrConference = isExternalCourse(topic?.type?.id) || isConference(topic?.type?.id);

  if (isWaiting && (isCorpCourse || isExternalOrConference)) {
    return <div className={css['Content-left-col-finished']}>{t('materialWaiting')}</div>;
  }

  if (
    (isApproved && isCorpCourse) ||
    (!statistic.isAvailableForViewBlocks &&
      (topicPlanStatus === WAITING_BY_USER || isApprovedStatus) &&
      isExternalOrConference)
  ) {
    return <div className={css['Content-left-col-finished']}>{t('approvedCorpCourse')}</div>;
  }

  if ((isFinished || alreadyFinished) && isNot25Type) {
    return <div className={css['Content-left-col-finished']}>{t('materialEnded')}</div>;
  }

  if (topicPlanStatus === 'inPlan' && statistic && isNot25Type) {
    if (!statistic.isAvailableForViewBlocks) {
      return <div className={css['Content-left-col-finished']}>{t('wait')}</div>;
    }
  }

  // if (topicPlanStatus === 'addToPlan') {
  //   return (
  //     <div className={css['Content-redirect']}>
  //       <Button className='add_to_plan_button' type='primary' size='large' onClick={() => setShowCalendar()}>
  //         {t('addToPlan')}
  //       </Button>
  //     </div>
  //   );
  // }

  // if (topicPlanStatus === 'unactive') {
  //   return (
  //     <div className={css['Content-redirect']}>
  //       <Button disabled size='large' type='primary'>
  //         {t('unActive')}
  //       </Button>
  //     </div>
  //   );
  // }

  if (topicPlanStatus === 'addToPlan' || topicPlanStatus === 'unactive') {
    return (
      <div className={css['Content-redirect']}>
        <MaterialButton topic={topic} inline noFavorite onSuccess={loadData} flagTopicId />
      </div>
    );
  }

  if (isNot25Type || topicPlanStatus !== 'inPlan') {
    return null;
  }

  if (statistic?.isAvailableForViewBlocks && !next && !isFinished && !alreadyFinished && isExecutiveFinished) {
    return (
      <Button
        onClick={() => handleEndMaterialButton()}
        className={css['endMaterialCenterButton']}
        size='large'
        type='primary'
      >
        {t('endExecutiveTask')}
      </Button>
    );
  }

  if (
    !next &&
    topic?.planStatus?.planStatus === 'REJECTED_BY_MANAGER' &&
    !isFinished &&
    !alreadyFinished &&
    isExecutiveFinished
  ) {
    return (
      <Button
        onClick={() => handleEndMaterialButton()}
        className={css['endMaterialCenterButton']}
        size='large'
        type='primary'
      >
        {t('endExecutiveTask')}
      </Button>
    );
  }

  if (statistic && topic?.planStatus) {
    if (topic.planStatus.planStatus === WAITING) {
      return <div className={css['Content-left-col-finished']}>{t('executiveWait')}</div>;
    }

    if (topic.planStatus.planStatus === 'REJECTED_BY_MANAGER') {
      return <div className={css['Content-left-col-finished']}>{t('executiveRejected')}</div>;
    }

    if (topic.planStatus.planStatus === FINISHED) {
      return <div className={css['Content-left-col-finished']}>{t('materialEnded')}</div>;
    }
  }

  return null;
};

export default TopicStudyInfo;
